import { render, staticRenderFns } from "./updateSupplier.vue?vue&type=template&id=c480f43e&scoped=true"
import script from "./updateSupplier.vue?vue&type=script&lang=js"
export * from "./updateSupplier.vue?vue&type=script&lang=js"
import style0 from "./updateSupplier.vue?vue&type=style&index=0&id=c480f43e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c480f43e",
  null
  
)

export default component.exports